(function ( $ ) {

    $(document).on('ready', function () {
        if ( document.body.classList.contains('wp-admin') ) {
            // when in admin-editor - looping hero-thumb aligning as it can not be 100% fully predicted when Property Hero block preview will be rendered in admin editor
            // (and also - if block was loaded in edit mode - this code will be looping till user will not turn block to preview mode)
            var interval = setInterval(function () {
                var $propsThumbs = $('.property-hero__thumb');
                if ( $propsThumbs.length > 0 ) {
                    alignThumbsHeight($propsThumbs);
                    clearInterval(interval); // stopping loop for hero-thumb aligning
                }
            }, 2000);
        }
        else {
            var isResponsive = $('#is-responsive').filter(':visible').length > 0;
            if ( !isResponsive ) {
                alignThumbsHeight($('.property-hero__thumb'));
            }
        }
    });

    function alignThumbsHeight($thumbs){
        if ( $thumbs.length > 0 ) {
            $thumbs.each(function () {
                var $this = $(this);
                var heroThumbHeight = $this.closest('.property-hero-grid').outerHeight();
                $this.height(heroThumbHeight).addClass('thumb-visible');
            });
        }
    }

})( jQuery )